import { useLazyQuery, useMutation } from "@apollo/client";
import FontPicker from "font-picker-react";
import PubSub from "pubsub-js";
import React, { useContext, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { NotificationManager } from "react-notifications";
import { useHistory, useLocation } from "react-router-dom";
import CommentsComponent from "../../components/CommentsComponent/CommentsComponent";
import EditorConvertToMarkdown from "../../components/EditorConvertToMarkdown";
import ModalApprovalSurvey from "../../components/ModalApprovalSurvey/ModalApprovalSurvey";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import OpenTextBox from "../../components/OpenTextBlock";
import {
  updateConfiguration,
  setStateSurveyConfiguration,
} from "../../helpers/StateSurveyConfiguration";
import SurveyQuestionConfiguration from "../../components/SurveyQuestionConfiguration";
import {
  CHANGE_STATE_FORM,
  CHANGE_STATE_SURVEY,
  CLONE_SURVEY_GLOBAL,
  UPDATE_MANY_QUESTIONS,
} from "../../GraphQL/Mutations";
import {
  APPROVER_COMMENTS_BY_SURVEY_ID,
  IS_APPROVER_FOR_SURVEY,
  SURVEY_BY_ID,
} from "../../GraphQL/Queries";
import { ContextQuestions } from "../../Store/StoreQuestions";
import BannerContainer from "../BannerContainer";
import DropdownSingleSelectContainer from "../DropdownSingleSelectContainer";
import ImageRatingContainer from "../ImageRatingContainer";
import MultipleChoiceMultiSelectContainer from "../MultipleChoiceMultiSelectContainer";
import MultipleChoiceSingleSelectContainer from "../MultipleChoiceSingleSelectContainer";
import MultipleChoiceSingleSelectImageContainer from "../MultipleChoiceSingleSelectImageContainer";
import QuestionLikeContainer from "../QuestionLikeContainer";
import QuestionYesNoContainer from "../QuestionYesNoContainer";
import SmileyFacesContainer from "../SmileyFacesContainer";
import {
  BlockWrapper,
  ButtonSubmit,
  ContainerLogo,
  GeneralStyle,
  HeaderDependency,
  PreviewElements,
  StyledButton,
  SurveyQuestionConfigurationContainer,
  TitlePreview,
} from "./SurveyPreviewPanel.styled.js";
import { getFile } from "../../services/FileManager";
import DateCalendarBlock from "../../components/DateCalendarBlock/DateCalendarBlock";
import ModalActivateAction from "../../components/ModalActivateAction/ModalActivateAction";
import AttachFileBlock from "../../components/AttachFileBlock";
import LocationTypeBlock from "../../components/LocationTypeBlock/LocationTypeBlock";
import PropTypes from "prop-types";

const SurveyPreviewPanel = ({
  idSurvey,
  ShowSurveyCreationMain,
  isSavedAsTemplate,
  styleSaveSurveyButton,
  OnlyAssigned,
  Anonymity,
  RandomQuestions,
  onlyReviewWithComments,
  fetchSurvey,
  integrationTpClient,
  selectedGuests,
  setShowSurveyCreationMain,
}) => {
  const location = useLocation();
  const routerPath = location.pathname;
  const history = useHistory();
  const [showLoader, setshowLoader] = useState(false);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [updateManyQuestions] = useMutation(UPDATE_MANY_QUESTIONS);
  const [surveyName, setSurveyName] = useState("");
  const [, setSurveyDescription] = useState("");
  const [title, setTitle] = useState("");
  const [footer, setFooter] = useState("");
  const [textButton, setTextButton] = useState("");
  const [colorPickerPreview, setColorPickerPreview] = useState("#ffffff");
  const [backgroundPreview, setBackgroundPreview] = useState("");
  const [LogoPreview, setLogoPreview] = useState("");
  const [sizeLogoPreview, setSizeLogoPreview] = useState({ width: "18%" });
  const [positionLogoPreview, setPositionLogoPreview] = useState("");
  let [, setPreview] = useState("");
  const [dataSurvey, setDataSurvey] = useState();
  const [openApprovalSurveyModal, setOpenApprovalSurveyModal] = useState();
  const [openActivateFormModal, setOpenActivateFormModal] = useState();
  const [showComments, setShowComments] = useState(false);
  const [changeStateSurvey] = useMutation(CHANGE_STATE_SURVEY);
  const [changeStateFormMutation] = useMutation(CHANGE_STATE_FORM);
  const [surveyStateId, setSurveyStateId] = useState(null);
  const [comments, setComments] = useState();
  const [renderAgain, setrenderAgain] = useState(false);
  const [activeSubmittApproval, setActiveSubmittApproval] = useState(false);
  const [isApproverForSurvey, setIsApproverForSurvey] = useState(false);
  const [activeFormAction, setActiveFormAction] = useState(false);
  const [cloneSurveyGlobal] = useMutation(CLONE_SURVEY_GLOBAL);
  const [itsIntegrationTpClient, setItsIntegrationTpClient] = useState(
    integrationTpClient != null
      ? integrationTpClient
      : routerPath === "/FormsManagement"
      ? true
      : false
  );

  const [runQueryApproverForSurvey] = useLazyQuery(IS_APPROVER_FOR_SURVEY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.isApproverForSurvey.outputData.isApproved) {
        setIsApproverForSurvey(data.isApproverForSurvey.outputData.isApproved);
      }
    },
  });

  const [runQueryApproverCommentsBySurveyId] = useLazyQuery(
    APPROVER_COMMENTS_BY_SURVEY_ID,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.approverCommentsBySurveyId.withError) {
          setComments(data.approverCommentsBySurveyId.outputData);
        } else {
          NotificationManager.error(
            data.approverCommentsBySurveyId.message,
            "",
            5000
          );
        }
      },
    }
  );

  const [runQuerySurvey] = useLazyQuery(SURVEY_BY_ID, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setDataSurvey({ ...data });
      if (data.surveyById) {
        let tpsurveyConfigurationSurveys =
          data.surveyById.tpsurveyConfigurationSurveys;

        let questions = tpsurveyConfigurationSurveys.filter(
          (f) => f.field === "Questions"
        );
        let answers = tpsurveyConfigurationSurveys.filter(
          (f) => f.field === "Answer"
        );
        if (questions.length) {
          dispatch({
            type: "QUESTIONS_STYLE",
            payload: JSON.parse(questions[0].jsonConfiguration),
          });
        }
        if (answers.length) {
          dispatch({
            type: "ANSWERS_STYLE",
            payload: JSON.parse(answers[0].jsonConfiguration),
          });
        }

        if (tpsurveyConfigurationSurveys) {
          let colorBackground = tpsurveyConfigurationSurveys.filter(
            (i) => i.field === "Background"
          )[0];
          let logo = tpsurveyConfigurationSurveys.filter(
            (i) => i.field === "Logo"
          )[0];
          if (logo) {
            getFile(JSON.parse(logo.jsonConfiguration).nameImage).then(
              (response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  PubSub.publish(
                    "urlPreviewImageLogo",
                    URL.createObjectURL(response)
                  );
                }
              }
            );
          }
          if (colorBackground) {
            let fileName = JSON.parse(
              colorBackground.jsonConfiguration
            ).nameImage;
            if (fileName) {
              getFile(fileName).then((response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  PubSub.publish(
                    "urlPreviewImageBackground",
                    URL.createObjectURL(response)
                  );
                }
              });
            } else {
              PubSub.publish("urlPreviewImageBackground", "");
            }
          } else {
            PubSub.publish("urlPreviewImageBackground", "");
          }
        }
        updateConfiguration(tpsurveyConfigurationSurveys);
        dispatch({ type: "CLEAN_QUESTIONS" });
        let tpsurveyQuestionSurveys = data.surveyById.tpsurveyQuestionSurveys;
        tpsurveyQuestionSurveys
          .filter((f) => f.active)
          .sort((a, b) => (a.order >= b.order ? 1 : -1))
          .map((item, index) => {
            let jsonConfSurveyQuestion = JSON.parse(item.jsonConfiguration);
            dispatch({
              type: "ADD_QUESTIONS",
              payload: {
                Gtype: jsonConfSurveyQuestion.typeQuestion,
                GindexQuestion: index,
                Gactive: item.active,
                GidSurvey: idSurvey,
                GidQuestion: item.idQuestion,
                GidCategoryQuestion:
                  item.idQuestionNavigation.idCategoryQuestion.toString(),
                GnameQuestion: item.idQuestionNavigation.nameQuestion,
                GvalidationText: item.idQuestionNavigation.validationText,
                GidQuestionSurvey: item.idQuestionSurvey,
                GisMandatory: item.isMandatory,
                GjsonConfiguration: item.jsonConfiguration,
                Gorder: item.order,
                GisEdit: false,
                GisDependent: item.isDependent,
                GidParentQuestion: item.isDependent ? item.idParentQuestion : 0,
                GdependentAnswer: item.isDependent ? item.dependentAnswer : "",
              },
            });
          });
      }
      setshowLoader(false);
    },
  });

  useEffect(() => {
    setshowLoader(true);
    runQuerySurvey({ variables: { idSurvey: idSurvey } });
    runQueryApproverForSurvey({ variables: { surveyId: idSurvey } });
  }, [fetchSurvey]);

  useEffect(() => {
    runQueryApproverCommentsBySurveyId({ variables: { surveyId: idSurvey } });
  }, [renderAgain]);

  useEffect(() => {
    if (dataSurvey && dataSurvey?.surveyById.idSurveyState) {
      setSurveyStateId(dataSurvey.surveyById.idSurveyState);
      //PubSub.publish('dataEditSurveyCreationMain', { dataSurvey, idSurvey })
    }
  }, [dataSurvey, idSurvey]);

  useEffect(() => {
    PubSub.subscribe("urlPreviewImageBackground", (e, data) => {
      setBackgroundPreview(data);
      setPreview("1");
    });

    PubSub.subscribe("urlPreviewImageLogo", (e, data) => {
      setLogoPreview(data);
      setPreview("1");
    });

    PubSub.subscribe("surveyConfiguration", (e, data) => {
      let nameTmp = data.filter((i) => i.field === "surveyName")[0];
      let descriptionTmp = data.filter(
        (i) => i.field === "surveyDescription"
      )[0];
      let titleTmp = data.filter((i) => i.field === "Title")[0];
      let footerTmp = data.filter((i) => i.field === "Footer")[0];
      let TextButtonSaveTmp = data.filter(
        (i) => i.field === "TextButtonSave"
      )[0];
      let colorBackground = data.filter((i) => i.field === "Background")[0];
      let logo = data.filter((i) => i.field === "Logo")[0];

      setSurveyName(
        nameTmp
          ? data.filter((i) => i.field === "surveyName")[0]?.configurationJson
              .text
          : ""
      );

      setSurveyDescription(
        descriptionTmp
          ? data.filter((i) => i.field === "surveyDescription")[0]
              ?.configurationJson.text
          : ""
      );
      setTitle(
        titleTmp
          ? data.filter((i) => i.field === "Title")[0]?.configurationJson.text
          : ""
      );
      setFooter(
        footerTmp
          ? data.filter((i) => i.field === "Footer")[0]?.configurationJson.text
          : ""
      );
      setTextButton(
        TextButtonSaveTmp
          ? data.filter((i) => i.field === "TextButtonSave")[0]
              ?.configurationJson.text
          : ""
      );
      setColorPickerPreview(
        colorBackground
          ? data.filter((i) => i.field === "Background")[0]?.configurationJson
              .color
          : colorPickerPreview
      );
      setSizeLogoPreview(
        logo
          ? data.filter((i) => i.field === "Logo")[0]?.configurationJson
              .sizeImage
          : sizeLogoPreview
      );
      setPositionLogoPreview(
        logo
          ? data.filter((i) => i.field === "Logo")[0]?.configurationJson
              .position
          : positionLogoPreview
      );
    });
    // PubSub.subscribe('draganddrop', (e, data) => {
    //     runQuerySurvey({ variables: { idSurvey: idSurvey } })
    // })
  }, []);

  useEffect(() => {
    if (title) {
      setStateSurveyConfiguration(title, "Title");
    }
  }, [title]);

  const OrderQuestions = () => {
    let data = [];
    stateQuestionsReducer.questions.forEach((question, index) => {
      question.Gorder = index + 1;
      question.GindexQuestion = index;
      data.push({
        idQuestionSurvey: question.GidQuestionSurvey,
        order: question.Gorder,
        idQuestion: question.GidQuestion,
      });
    });
    updateManyQuestions({
      variables: {
        questions: { questionSurveys: data },
      },
    }).then((response) => {
      if (response.data.updateManyQuestionSurvey.withError) {
        NotificationManager.error("Error updating questions", "", 5000);
      } else {
        let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
        dispatch({ type: "CLEAN_QUESTIONS" });
        dispatch({ type: "DELETE_QUESTIONS", payload: copy });
      }
      setshowLoader(false);
    });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;
    if (stateQuestionsReducer.questions[result.source.index].GisDependent) {
      NotificationManager.warning(
        "You can not move it, this question is dependent on another",
        "",
        5000
      );
      return;
    }
    if (stateQuestionsReducer.questions.filter((f) => f.GisEdit).length) {
      NotificationManager.warning(
        "You have pending questions to save",
        "",
        5000
      );
      return;
    }
    if (
      (result.destination.index > result.source.index &&
        stateQuestionsReducer.questions[result.destination.index + 1] !=
          undefined &&
        stateQuestionsReducer.questions[result.destination.index + 1]
          .GisDependent) ||
      (result.destination.index < result.source.index &&
        stateQuestionsReducer.questions[result.destination.index].GisDependent)
    ) {
      NotificationManager.warning(
        "You can not move the question inside the dependent questions",
        "",
        5000
      );
      return;
    }
    setshowLoader(true);
    const [reorderedItem] = stateQuestionsReducer.questions.splice(
      result.source.index,
      1
    );
    stateQuestionsReducer.questions.splice(
      result.destination.index,
      0,
      reorderedItem
    );

    stateQuestionsReducer.questions
      .filter((f) => f.GidParentQuestion == reorderedItem.GidQuestionSurvey)
      .map((m) => {
        const [reorderedItem] = stateQuestionsReducer.questions.splice(
          stateQuestionsReducer.questions.findIndex(
            (i) => i.GidQuestionSurvey == m.GidQuestionSurvey
          ),
          1
        );
        stateQuestionsReducer.questions.splice(
          result.destination.index < result.source.index
            ? result.destination.index + 1
            : result.destination.index,
          0,
          reorderedItem
        );
      });

    OrderQuestions();
  };

  const renderQuestions = (q, index, array) => {
    // let colorHeader = 0
    //   if (q.GidParentQuestion != 0) {
    //     let flagParent = q.GidParentQuestion
    //     while (flagParent > 0) {
    //       let position = array.findIndex(i => i.GidQuestionSurvey == flagParent)
    //       if (position >= 0) {
    //         flagParent = array[position].GidParentQuestion
    //         colorHeader++
    //       }
    //       else {
    //         flagParent = 0
    //       }
    //     }
    //     colorHeader= colorHeader == 1 ?'0':Math.floor(((colorHeader/10)*16777215)).toString(16)
    //   }

    switch (q.Gtype) {
      case "OpenText":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <OpenTextBox
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                isGlobal={dataSurvey?.surveyById?.isGlobal}
                dataSurvey={dataSurvey?.surveyById}
                show
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "ImageRating":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <ImageRatingContainer
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "MultipleChoiceMultiSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <MultipleChoiceMultiSelectContainer
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "MultipleChoiceSingleSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <MultipleChoiceSingleSelectContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "MultipleChoiceImageSingleSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <MultipleChoiceSingleSelectImageContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "SmileyFaces":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <SmileyFacesContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "QuestionYesNo":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <QuestionYesNoContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "QuestionLike":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <QuestionLikeContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "InfoBanner":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={index}>
              <BannerContainer {...q} />
            </BlockWrapper>
          </>
        );
      case "DropdownSingleSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <DropdownSingleSelectContainer
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
              />
            </BlockWrapper>
          </>
        );
      case "Date":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <DateCalendarBlock
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "File":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <AttachFileBlock
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "Location":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !=
                array[index == 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <LocationTypeBlock
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                dataSurvey={dataSurvey?.surveyById}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      default:
        break;
    }
  };

  const changeState = (id) => {
    setshowLoader(true);
    let variable = {
      idSurvey: id,
      newSurveyState: "READY_FOR_APPROVAL",
    };
    changeStateSurvey({
      variables: variable,
    }).then((value) => {
      setshowLoader(false);
      if (value.data.changeStateSurvey.withError !== true) {
        if (
          dataSurvey?.surveyById?.isGlobal &&
          idSurvey &&
          dataSurvey?.surveyById?.tpsurveyGlobalClients.length > 0
        ) {
          const isTemplate = isSavedAsTemplate
            ? isSavedAsTemplate
            : dataSurvey?.surveyById?.isTemplate;
          const clientTpCodes =
            dataSurvey?.surveyById?.tpsurveyGlobalClients.map(
              (c) => c.clientTpCode
            );
          cloneSurveyGlobal({
            variables: {
              surveyModel: {
                idSurvey: idSurvey,
                clientTpCodes: clientTpCodes,
                cloneAsTemplate: isTemplate,
              },
            },
          }).catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
        }
        if (dataSurvey?.surveyById?.isGlobal) {
          NotificationManager.success(
            "Successfully sent to all clients",
            "",
            5000
          );
        } else {
          NotificationManager.success("Ready for approval", "", 5000);
        }

        history.push(`/Gamification`);
        setTimeout(() => {
          history.push(`/ManageSurvey`);
        }, 1);
      } else {
        NotificationManager.error(
          "Error to submitt approval for this survey",
          "",
          5000
        );
      }
      setshowLoader(false);
    });
  };

  let changeStateForm = (id) => {
    setshowLoader(true);
    let variable = {
      idForm: id,
      newFormState: "ACTIVE",
    };

    changeStateFormMutation({
      variables: variable,
    }).then((value) => {
      setshowLoader(false);
      if (value.data.changeStateForm.withError !== true) {
        NotificationManager.success("Form Activated", "", 5000);
        history.push(`/Gamification`);
        setTimeout(() => {
          history.push(`/FormsManagement`);
        }, 1);
      } else {
        NotificationManager.error("Error activating this form", "", 5000);
      }
      setshowLoader(false);
    });
  };

  let showModalApprovalSurvey = () => {
    return (
      openApprovalSurveyModal && (
        <ModalApprovalSurvey
          title={
            dataSurvey?.surveyById?.isGlobal
              ? "Are you sure you want to send to all Clients?"
              : "Are you sure you want to send to approval your survey?"
          }
          description={
            dataSurvey?.surveyById?.isGlobal
              ? "If you click OK, This survey send to all clients which you  selected"
              : "If you click OK, you will not be able to  edit your survey unless your approver send it back with comments or corrections"
          }
          open={openApprovalSurveyModal}
          setOpen={setOpenApprovalSurveyModal}
          fn={changeState}
        />
      )
    );
  };

  let showModalActivateForm = () => {
    return (
      openActivateFormModal && (
        <ModalActivateAction
          title={"Are you sure you want to activate this form?"}
          open={openActivateFormModal}
          setOpen={setOpenActivateFormModal}
          fn={changeStateForm}
        />
      )
    );
  };

  let handleComments = () => {
    setShowComments(!showComments);
  };

  return (
    <>
      <GeneralStyle
        colorPickerPreview={colorPickerPreview}
        backgroundPreview={backgroundPreview}
      >
        <SurveyQuestionConfigurationContainer
          surveyStateId={surveyStateId}
          activeSubmittApproval={activeSubmittApproval}
          idSurvey={idSurvey}
        >
          <TitlePreview>
            <span>{surveyName}</span>
          </TitlePreview>
          {surveyStateId &&
            surveyStateId !== 6 &&
            idSurvey &&
            activeSubmittApproval && (
              <ButtonSubmit
                onClick={() => {
                  setOpenApprovalSurveyModal(idSurvey);
                }}
              >
                {dataSurvey?.surveyById?.isGlobal
                  ? "Send to all clients"
                  : "Submit for approval"}
              </ButtonSubmit>
            )}

          {surveyStateId &&
            surveyStateId !== 6 &&
            surveyStateId !== 2 &&
            idSurvey &&
            activeFormAction && (
              <ButtonSubmit
                onClick={() => {
                  if (selectedGuests?.length > 0) {
                    setOpenActivateFormModal(idSurvey);
                  } else {
                    NotificationManager.warning(
                      "Please assign the form to users",
                      "",
                      5000
                    );
                    setActiveFormAction(false);
                  }
                }}
              >
                Activate Form
              </ButtonSubmit>
            )}

          <SurveyQuestionConfiguration
            idSurvey={idSurvey}
            OnlyAssigned={OnlyAssigned}
            Anonymity={Anonymity}
            RandomQuestions={RandomQuestions}
            setActiveSubmittApproval={setActiveSubmittApproval}
            setActiveForm={setActiveFormAction}
            onlyReviewWithComments={onlyReviewWithComments}
            surveyStateId={surveyStateId}
            handleComments={handleComments}
            itsForm={itsIntegrationTpClient}
          />
        </SurveyQuestionConfigurationContainer>
        {LogoPreview !== "#" ? (
          <ContainerLogo positionLogoPreview={positionLogoPreview}>
            <img style={sizeLogoPreview} src={LogoPreview} alt="" />
          </ContainerLogo>
        ) : null}
        <div className="title-field">
          <EditorConvertToMarkdown
            disableTextArea={surveyStateId === 6}
            editor={title}
            setEditor={(value) =>
              setTitle(value.substring(0, value.length - 1))
            }
            style={{ width: "80%", maxWidth: "684px" }}
            placeHolder={
              itsIntegrationTpClient
                ? "Add form title here"
                : "Add survey title here"
            }
          />
        </div>
        <PreviewElements>
          <div hidden={surveyStateId === 6}>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="droppable-1">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {stateQuestionsReducer.questions.map((q, index, array) => (
                      <Draggable
                        key={q.GidQuestion}
                        draggableId={`draggable-${index}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            {renderQuestions(q, index, array)}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <div hidden={surveyStateId != 6}>
            {stateQuestionsReducer.questions.map((q, index, array) => (
              <div key={q.GidQuestion}>{renderQuestions(q, index, array)}</div>
            ))}
          </div>
          {textButton && textButton.trim() !== "" ? (
            <StyledButton style={styleSaveSurveyButton}>
              {textButton}
            </StyledButton>
          ) : null}
          <footer>
            <div
              dangerouslySetInnerHTML={{
                __html: footer,
              }}
            ></div>
          </footer>
        </PreviewElements>
        {/*BEGIN THIS IS FOR GETTING FONTS IN THE PREVIEW PANEL  */}
        <div style={{ display: "none" }}>
          <FontPicker
            pickerId={"prueba"}
            apiKey={process.env.GOOGLE_API_KEY}
            activeFontFamily={"Open Sans"}
            limit={100}
            onChange={(event) => {}}
          />
        </div>
        {/*END THIS IS FOR GETTING FONTS IN THE PREVIEW PANEL  */}
      </GeneralStyle>
      {showModalApprovalSurvey()}
      {showModalActivateForm()}
      {showComments && (
        <CommentsComponent
          surveyStateId={surveyStateId}
          idSurvey={idSurvey}
          comments={comments}
          isApproverForSurvey={isApproverForSurvey}
          handleComments={handleComments}
          renderAgain={renderAgain}
          setrenderAgain={setrenderAgain}
          setComments={setComments}
        />
      )}
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default SurveyPreviewPanel;

SurveyPreviewPanel.propTypes = {
  idSurvey: PropTypes.number,
  isSavedAsTemplate: PropTypes.bool,
  ShowSurveyCreationMain: PropTypes.any,
  styleSaveSurveyButton: PropTypes.any,
  OnlyAssigned: PropTypes.bool,
  Anonymity: PropTypes.bool,
  RandomQuestions: PropTypes.bool,
  onlyReviewWithComments: PropTypes.bool,
  fetchSurvey: PropTypes.bool,
  integrationTpClient: PropTypes.any,
  selectedGuests: PropTypes.array,
  setShowSurveyCreationMain: PropTypes.func,
};
